import React from 'react';

interface Icon3DTransparencyProps {
  size?: string;
}

const Icon3DTransparency: React.FC<Icon3DTransparencyProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'eye-blink 3s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" className="w-full h-full" style={{ filter: 'drop-shadow(0 2px 8px rgba(16, 185, 129, 0.3))' }}>
          <defs>
            <linearGradient id="transparencyGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#10b981" />
              <stop offset="100%" stopColor="#059669" />
            </linearGradient>
          </defs>
          <path d="M12 5C7 5 2.73 8.11 1 12.46c1.73 4.35 6 7.54 11 7.54s9.27-3.19 11-7.54C21.27 8.11 17 5 12 5z" fill="url(#transparencyGradient)" opacity="0.2" />
          <circle cx="12" cy="12" r="4" fill="url(#transparencyGradient)" opacity="0.5" />
          <circle cx="12" cy="12" r="2.5" fill="url(#transparencyGradient)" />
        </svg>
        <style>{`
          @keyframes eye-blink {
            0%, 100% { transform: rotateX(0deg); }
            25% { transform: rotateX(25deg); }
            50% { transform: rotateX(0deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DTransparency;
